module.exports = __webpack_public_path__ + "static/media/480.42ae3283.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-insecticide/dark/480.png
// module id = 2192
// module chunks = 2